import React, { useEffect, useState } from 'react';
import HeaderStyleThree from '../../components/Layout/Header/HeaderStyleThree';
import Footer from '../../components/Layout/Footer';
import BackToTop from '../../components/elements/BackToTop';
import EventsHero from './EventsHero';
import UpcomingEvents from './UpcomingEvents';
import GallerySection from '../home-3/GallerySection';
import PastEvents from './PastEvents';


const CommunityEventsPage = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const handleScroll = () => setIsVisible(window.scrollY > 300);
        document.addEventListener('scroll', handleScroll);
        return () => document.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <div className="homestyle2">
            <HeaderStyleThree />
            <EventsHero />
            <UpcomingEvents />
            <GallerySection />
            <PastEvents />

            <BackToTop scroll={isVisible} />
            <Footer />
        </div>
    );
};

export default CommunityEventsPage;
